<template>
    <div class="time_sheet loading_top_wrap">
        <div v-if="isLoading" class="loading_bg round_none transparent" style="z-index: 100">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="all_block" v-if="isHoliday">
            <div class="desc">예약을 운영하지 않는 날입니다.</div>
        </div>
        <div class="time_sheet_scroll" ref="scroll" v-clickoutside:action_MouseClickOutside="{}" @mousemove="action_MouseMove">
            <!-- 시간 축 -->
            <TimeField :selectedAreaHelper="selectedAreaHelper" :scroll="$refs.scroll" />
            <!-- 그룹 -->
            <Group
                v-for="(group, index) in groups"
                :key="index"
                :groups="groups"
                :group="group"
                :index="index"
                :selectedAreaHelper="selectedAreaHelper"
                :hoverReservation="hoverReservation"
                :originalWorkRecords="originalWorkRecords"
                :originalBlocksAndColors="originalBlocksAndColors"
                @action_ReservationMouseOver="handleReservationMouseOver"
            />
            <!-- 현재시각 -->
            <NowLine />
            <!-- 너비 조절 가이드 -->
            <ColumnWidthGuide :scroll="$refs.scroll" />
            <!-- 컬럼 선택 혹은 드래그 시 -->
            <SelectedArea :selectedAreaHelper="selectedAreaHelper" :groups="groups" />
            <!-- 우클릭 -->
            <ReservationMenu />
            <GroupMenu />
            <ColumnMenu />
            <CellMenu />

            <!-- 예약미리보기 -->
            <ReservationPreviewOverlay :isShow="isShowPreview" :isEnterSheet="true" :hoverEvent="hoverEvent" :reservation="hoverReservation" />

            <!-- 시간선택상태 -->
            <TimeSelectInfo :position="mousePoint" />

            <!-- 셀에서 예약등록 -->
            <HServiceSearchPopup />
        </div>

        <!-- 예약 설정 -->
        <ReservationSettingPopup :isShow="isShowSettingPopup" :selectedAreaHelper="selectedAreaHelper" @handlerHideSettingPopup="handlerHideSettingPopup" />
        <!-- 예약 생성/수정 -->
        <ReservationEditPopup />
        <!-- 그룹 생성/수정 -->
        <GroupEditPopup />
        <!-- 컬럼 생성/수정 -->
        <ColumnEditPopup />
        <!-- 엑셀 저장 팝업 -->
        <ExcelSavePopup v-if="sheetOverlays.isShowExcelSavePopup" />
        <!-- 예약현황 팝업 -->
        <ReservationMonitorPopup />
        <!-- 예약기록 팝업 -->
        <ReservationHistoryPopup />
        <!-- 공지사항 팝업 -->
        <ReservationDateNotePopup />
        <!-- 근무 스케쥴 팝업 -->
        <ReservationWorkStatePopup />
        <!-- 색상 수정 팝업 -->
        <ColorEditPopup :selectedAreaHelper="selectedAreaHelper" />
        <!-- 예약금지 팝업 -->
        <ReservationBlockPopup :selectedAreaHelper="selectedAreaHelper" />
        <!-- 예약금지 옵션 팝업 -->
        <BlockRepeatOptionPopup />
        <!-- AI 예약 알림 설정 팝업 -->
        <AIReservationMessageEditPopup
            :isShow="sheetOverlays.isShowAIMessageEditPopup"
            @close="handleAIMessageEditClose"
        />
        <!-- AI 예약 상세 설정 팝업 -->
        <AIReservationDetailEditPopup
            :isShow="sheetOverlays.isShowAIDetailEditPopup"
            :initialStartValue="aiDetailStartValue"
            :initialStartUnit="aiDetailStartUnit"
            :initialEndDays="aiDetailEndDays"
            :initialInterval="aiDetailInterval"
            :initialUsingDefaultInterval="aiDetailUsingDefaultInterval"
            :initialTimeIntervals="aiDetailTimeIntervals"
            :initialMaxCapacity="aiDetailMaxCapacity"
            @close="handleAIDetailEditClose"
            @save="handleAIDetailEditSave"
        />

        <!-- Alerts -->
        <AlertUserInfoEditPopup />
        <AlertPhoneEdit />
        <AlertSendPush />
        <AlertRemoveConfirm />
        <AlertGroupRemoveConfirm />
        <AlertColumnRemoveConfirm />
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import TimeField from './Time/TimeField.vue'
import Group from './Column/Group.vue'
import NowLine from './Column/NowLine.vue'
import ColumnWidthGuide from './Column/ColumnWidthGuide.vue'
import SelectedArea from './Column/SelectedArea.vue'
import ReservationMenu from '../Common/ReservationMenu/ReservationMenu.vue'
import GroupMenu from '../Common/GroupMenu/GroupMenu.vue'
import ColumnMenu from '../Common/ColumnMenu/ColumnMenu.vue'
import CellMenu from '../Common/CellMenu/CellMenu.vue'

import HServiceSearchPopup from '../Popups/HServiceSearchPopup/HServiceSearchPopup.vue'
import TimeSelectInfo from './Column/TimeSelectInfo.vue'

import AlertUserInfoEditPopup from '../Popups/AlertPopup/AlertUserInfoEdit.vue'
import AlertPhoneEdit from '../Popups/AlertPopup/AlertPhoneEdit.vue'
import AlertSendPush from '../Popups/AlertPopup/AlertSendPush.vue'
import AlertRemoveConfirm from '../Popups/AlertPopup/AlertRemoveConfirm.vue'
import AlertGroupRemoveConfirm from '../Popups/AlertPopup/AlertGroupRemoveConfirm.vue'
import AlertColumnRemoveConfirm from '../Popups/AlertPopup/AlertColumnRemoveConfirm.vue'

import ReservationPreviewOverlay from '../Popups/ReservationPopup/Left/Components/ReservationPreviewOverlay.vue'

import ReservationSettingPopup from '../Popups/ReservationSettingPopup/ReservationSettingPopup.vue'
import ReservationEditPopup from '../Popups/ReservationPopup/ReservationPopup.vue'
import GroupEditPopup from '../Popups/GroupEditPopup/GroupEditPopup.vue'
import ColumnEditPopup from '../Popups/ColumnEditPopup/ColumnEditPopup.vue'

import ExcelSavePopup from '../Popups/ExcelSavePopup/ExcelSavePopup.vue'
import ReservationMonitorPopup from '../Popups/ReservationMonitorPopup/ReservationMonitorPopup.vue'
import ReservationHistoryPopup from '../Popups/HistoryPopup/ReservationHistoryPopup.vue'
import ReservationDateNotePopup from '../Popups/DateNotePopup/ReservationDateNotePopup.vue'
import ReservationWorkStatePopup from '../Popups/WorkStatePopup/WorkStatePopup.vue'
import ReservationBlockPopup from '../Popups/ReservationBlockPopup/ReservationBlockPopup.vue'
import BlockRepeatOptionPopup from '../Popups/BlockRepeatOptionPopup/BlockRepeatOptionPopup.vue'
import ColorEditPopup from '../Popups/ColorEditPopup/ColorEditPopup.vue'
import AIReservationMessageEditPopup from '../Popups/ReservationSettingPopup/Components/AIReservationMessageEditPopup.vue'
import AIReservationDetailEditPopup from '../Popups/ReservationSettingPopup/Components/AIReservationDetailEditPopup.vue'

import { setReservationUserNotes, sheetState } from '../../sheet-state'
import { hideAIDetailEditPopup, hideAIMessageEditPopup, hideCellMenu, hideReservationMenu, sheetOverlays } from '../../sheet-overlays'
import { reservationSelection } from '../../reservation-selection'
import { sheetAxis } from '../../sheet-axis'
import { sheetFilters, selectedColumns, selectedGroups } from '../../sheet-filters'
import { sheetRefresh, handleRefresh, requestReservationRefresh } from '../../sheet-refresh'
import SelectHelper from '../../V2ReservationSelectAreaHelper'

import { mapState } from 'vuex'

import { timeHeight, moveTimeResize, endTimeResize } from './Time/time-height'
import { columnWidth, endColumnResize, moveColumnResize } from './Column/column-width'
import moment from '@/util/MPMoment'
import axios from 'axios'
import { useQueryClient } from '@tanstack/vue-query'
import { v2WorkHolidayFindDateQueryOptions } from '@/composables/queries/v2workholiday/use-v2-workholiday-find-date-query'
import { v2WorkRecordFindDateQueryOptions } from '@/composables/queries/v2workrecord/use-v2-workrecord-find-date-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
import { v2ReservationCellKeys, v2ReservationCellFindQueryOptions } from '@/composables/queries/v2reservationcell/use-v2-reservationcell-find-query'
import { v2ReservationBlockKeys, v2ReservationBlockFindQueryOptions } from '@/composables/queries/v2reservationblock/use-v2-reservationblock-find-query'
import { v2ReservationUserNoteFindDateQueryOptions } from '@/composables/queries/v2reservationusernote/use-v2-reservationusernote-find-date-query'

export default {
    setup() {
        const queryClient = useQueryClient()
        return { queryClient }
    },
    components: {
        TimeField,
        Group,
        NowLine,
        ColumnWidthGuide,
        SelectedArea,
        ReservationMenu,
        GroupMenu,
        ColumnMenu,
        CellMenu,
        AlertUserInfoEditPopup,
        AlertPhoneEdit,
        AlertSendPush,
        AlertRemoveConfirm,
        AlertGroupRemoveConfirm,
        AlertColumnRemoveConfirm,
        ReservationSettingPopup,
        GroupEditPopup,
        ColumnEditPopup,
        ExcelSavePopup,
        HServiceSearchPopup,
        TimeSelectInfo,
        ReservationPreviewOverlay,
        ReservationEditPopup,
        ReservationMonitorPopup,
        ReservationHistoryPopup,
        ReservationDateNotePopup,
        ReservationWorkStatePopup,
        ReservationBlockPopup,
        BlockRepeatOptionPopup,
        ColorEditPopup,
        AIReservationMessageEditPopup,
        AIReservationDetailEditPopup
    },
    props: {
        isShowSettingPopup: Boolean
    },
    data() {
        return {
            sheetState,
            sheetOverlays,
            reservationSelection,
            sheetAxis,
            sheetFilters,
            sheetRefresh,
            timeHeight,
            columnWidth,
            selectedAreaHelper: new SelectHelper.V2ReservationSelectAreaHelper(),

            mousePoint: { x: 0, y: 0 },

            hoverEvent: {},
            isShowPreview: false,
            hoverReservation: undefined,

            lastFetchDate: undefined,
            targetDate: undefined,
            isWorkHoliday: false,

            originalWorkRecords: [],
            originalBlocksAndColors: [],


            // AI 예약 상세 설정
            aiDetailResult: undefined
        }
    },
    watch: {
        groups: {
            deep: true,
            handler: function (newValue) {
                this.sheetFilters.usableGroups = newValue
            }
        },
        'remote_notification.d_v2ReservationSettingUpdate_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2ReservationCreate_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2ReservationUpdate_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2ReservationCancel_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2ReservationRemove_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2ReservationBlockCreate_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2ReservationBlockUpdate_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2ReservationBlockRemove_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2ReservationCellCreate_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2ReservationCellUpdate_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2ReservationCellRemove_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2WorkRecordUpdateBatch_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2WorkHolidayCreate_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'remote_notification.d_v2WorkHolidayRemove_el': {
            deep: true,
            handler: 'handleNotificationUpdate'
        },
        'sheetFilters.columns': {
            deep: true,
            handler: function (newValue, oldValue) {
                if(newValue != oldValue) {
                    this.initData()
                }
            }
        },
        'sheetRefresh.refreshFlagMoment': {
            deep: true,
            handler: function () {
                this.initData()
            }
        },
        'sheetRefresh.reservationRefreshEvent': {
            handler: function () {
                this.requestFetchReservationUserNotes()
            }
        },
        'reservationSelection.selectedReservationElement': {
            handler: function (newValue, oldValue) {
                if (newValue == oldValue) {
                    return
                }
                if (newValue == undefined) {
                    return
                }
                this.moveToReservationCell()
            }
        },
        selectedDate: {
            immediate: true,
            deep: true,
            handler: function () {
                this.selectedAreaHelper.clearStartEndPoint()
                this.selectedAreaHelper.clearSelectedRange()
            }
        },
        isHoliday: {
            handler: function (newValue) {
                this.sheetState.isHoliday = newValue ?? false
            }
        }
    },
    computed: {
        ...mapState(['remote_notification']),
        groups: function () {
            let groups = deepCopy(selectedGroups()) ?? []
            if (groups.length != 0 && groups)
                groups.forEach((g) => {
                    let groupID = g._id
                    g.columns = this.columns.filter((c) => c.isSelected == true && c.groupID == groupID)
                    if (g.columns.length == 0) {
                        g.columns.push({ isEmpty: true, _id: undefined, groupID: groupID })
                    }
                })
            groups.sort((l, r) => {
                return (l.order ?? 0) - (r.order ?? 0)
            })
            if (groups.length == 0) {
                groups.push({ _id: undefined })
            }
            return groups
        },
        columns: function () {
            return selectedColumns()
        },
        columnIds: function () {
            return this.columns.map((c) => c._id)
        },
        isTimeSelectMode: function () {
            return this.reservationSelection.isTimeSelectMode
        },
        selectedDate: function () {
            return moment(this.sheetAxis.selectedDate).startOf('days').toString()
        },
        isLoading: function () {
            return this.sheetState.isSheetCellsLoading
        },
        isTimeHeightEvent: function () {
            return this.timeHeight.isResizing == true
        },
        isColumnWidthEvent: function () {
            return this.columnWidth.isResizing == true
        },
        dayOfWeek: function () {
            let dayOfWeek = moment(this.sheetAxis.selectedDate).day()
            return dayOfWeek == 0 ? 7 : dayOfWeek
        },
        impossibleTime: function () {
            return (
                this.sheetState.reservationSetting?.possibleTimes?.some((t) => {
                    return t.index == this.adjustDayOfWeek(this.dayOfWeek) && !t.isSelected
                }) ?? false
            )
        },
        isHoliday: function () {
            return this.isWorkHoliday || this.impossibleTime
        },
        // AI 예약 상세 설정
        aiDetailStartValue: function () {
            return this.aiDetailResult?.startValue ?? 1
        },
        aiDetailStartUnit: function () {
            return this.aiDetailResult?.startUnit ?? 'day'
        },
        aiDetailEndDays: function () {
            return this.aiDetailResult?.endDays ?? 14
        },
        aiDetailInterval: function () {
            return this.aiDetailResult?.interval ?? 60
        },
        aiDetailUsingDefaultInterval: function () {
            return this.aiDetailResult?.usingDefaultInterval ?? true
        },
        aiDetailTimeIntervals: function () {
            return this.aiDetailResult?.timeIntervals ?? []
        },
        aiDetailMaxCapacity: function () {
            return this.aiDetailResult?.maxCapacity ?? 1
        }
    },
    mounted() {
        this.addEventListener()
        this.sheetState.sheetElement = this.$el
        this.sheetState.sheetScrollElement = this.$refs.scroll
    },
    beforeDestroy() {
        this.removeEventListener()
    },
    methods: {
        // MARK: - AI 예약 알림 설정
        handleAIMessageEditClose() {
            hideAIMessageEditPopup()
        },
        // MARK: - AI 예약 상세 설정
        handleAIDetailEditClose() {
            hideAIDetailEditPopup()
        },
        async handleAIDetailEditSave(data) {
            // TODO: AI 예약 상세 설정 저장 API 연동
            this.aiDetailResult = {
                ...this.aiDetailResult,
                startValue: data.startValue,
                startUnit: data.startUnit,
                endDays: data.endDays,
                interval: data.interval,
                usingDefaultInterval: data.usingDefaultInterval,
                timeIntervals: data.timeIntervals,
                maxCapacity: data.maxCapacity
            }
            hideAIDetailEditPopup()
        },
        initData() {
            let selectedDateString = moment(this.selectedDate).format('YYYY-MM-DD')
            if (selectedDateString != this.lastFetchDate) {
                this.originalWorkRecords = []
                this.originalBlocksAndColors = []
                setReservationUserNotes([])
            }
            this.lastFetchDate = selectedDateString
            this.requestFetchWorkHoliday()
            this.requestFetchWorkRecords()
            this.requestFetchReservationBlockAndColor()
            this.requestFetchReservationUserNotes()
        },
        handleNotificationUpdate(newValue) {
            if (newValue?.data?.hospitalID == this.hospital.selectedHospital._id) {
                switch (newValue?.data?.code) {
                    case 'd_v2WorkHolidayCreate_el':
                    case 'd_v2WorkHolidayRemove_el':
                        this.handleHolidayNotification(newValue)
                        break
                    case 'd_v2ReservationCreate_el':
                    case 'd_v2ReservationUpdate_el':
                    case 'd_v2ReservationCancel_el':
                    case 'd_v2ReservationRemove_el':
                        this.handleReservationNotification(newValue)
                        break
                    default:
                        handleRefresh()
                }
            }
        },
        handleReservationNotification(newValue) {
            const data = newValue?.data ?? {}
            const isUpdate = data.code == 'd_v2ReservationUpdate_el'

            // update인데 prevColumnID가 없으면 기존처럼 전체 columns 조회 플래그
            const isAllColumns = !data.columnID || (isUpdate && !data.prevColumnID);

            requestReservationRefresh({
                columnIDs: [data.columnID, data.prevColumnID],
                isAllColumns
            })
        },
        handleHolidayNotification(newValue) {
            let updatedDate = moment(newValue.data.date).format('YYYY-MM-DD')
            let selectedDate = moment(this.selectedDate).format('YYYY-MM-DD')
            if (updatedDate == selectedDate) {
                this.requestFetchWorkHoliday(true)
            }
        },
        handlerHideSettingPopup() {
            this.$emit('hideSettingPopup')
        },
        adjustDayOfWeek(dayOfWeek) {
            if (dayOfWeek === 7) {
                return 0
            } else {
                return dayOfWeek
            }
        },
        // MARK: - Actions
        action_MouseMove(e) {
            if (this.isTimeSelectMode) {
                this.reservationSelection.isShowTimeSelectInfo = true
                let rect = this.$el.getBoundingClientRect()
                let x = e.clientX - rect.x + 10
                let y = e.clientY - rect.y + 10
                if (this.$refs.scroll != undefined) {
                    let el = this.$refs.scroll
                    x += el.scrollLeft
                    y += el.scrollTop
                }
                this.mousePoint = { x: x, y: y }
            }
        },
        action_MouseClickOutside() {
            hideCellMenu()
            hideReservationMenu()
        },
        action_MouseMoveOutside() {
            this.reservationSelection.isShowTimeSelectInfo = false
        },
        action_ResizeMouseMove(e) {
            if (this.isTimeHeightEvent) {
                moveTimeResize(e)
            }
            if (this.isColumnWidthEvent) {
                moveColumnResize(e)
            }
        },
        action_ResizeMouseUp() {
            if (this.isTimeHeightEvent) {
                endTimeResize()
            }
            if (this.isColumnWidthEvent) {
                endColumnResize()
            }
        },
        // MARK: - Event Listeners
        addEventListener() {
            window.addEventListener('keyup', this.handleKeyUp)
            window.addEventListener('mousemove', this.action_ResizeMouseMove)
            window.addEventListener('mouseup', this.action_ResizeMouseUp)
        },
        removeEventListener() {
            window.removeEventListener('keyup', this.handleKeyUp)
            window.removeEventListener('mousemove', this.action_ResizeMouseMove)
            window.removeEventListener('mouseup', this.action_ResizeMouseUp)
        },
        handleKeyUp(e) {
            if (e.keyCode == 27) {
                if (this.sheetOverlays.isShowReservationMenu == true) {
                    this.sheetOverlays.isShowReservationMenu = false
                }
            }
        },
        handleReservationMouseOver(reservation, hoverEvent, isShowPreview) {
            let parentBoundingRect = this.$el.getBoundingClientRect()
            let xRelativeToParent = hoverEvent.x - parentBoundingRect.left + 10
            let yRelativeToParent = hoverEvent.y - parentBoundingRect.top

            this.isShowPreview = isShowPreview
            this.hoverReservation = deepCopy(reservation)

            if (this.$refs.scroll != undefined) {
                let el = this.$refs.scroll
                xRelativeToParent += el.scrollLeft
                yRelativeToParent += el.scrollTop

                this.hoverEvent = {
                    x: xRelativeToParent,
                    y: yRelativeToParent,
                    ref: el
                }
            }
        },
        // MARK: - Network
        async requestFetchWorkHoliday(refresh) {
            try {
                let hospitalID = this.hospital.selectedHospital._id
                let date = moment(this.selectedDate).format('YYYY-MM-DD')
                if (this.targetDate == date && !refresh) {
                    return
                }
                this.targetDate = date

                let params = {
                    hospitalID: hospitalID,
                    startDate: date,
                    endDate: date,
                    isRemoved: false
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                const holidays = await this.queryClient.fetchQuery(v2WorkHolidayFindDateQueryOptions(params))
                this.isWorkHoliday = holidays?.length > 0
            } catch (err) {
                this.isWorkHoliday = false
                console.log('Error fetching work holiday: ', err)
            }
        },

        // MARK: - Network
        async requestFetchWorkRecords() {
            try {
                let date = moment(this.selectedDate).format('YYYY-MM-DD')
                let hospitalID = this.hospital.selectedHospital._id

                let params = {
                    hospitalID: hospitalID,
                    startDate: date,
                    endDate: date,
                    isRemoved: false
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                const workRecords = await this.queryClient.fetchQuery(v2WorkRecordFindDateQueryOptions(params))
                this.originalWorkRecords = workRecords.filter(w => w.workCodeID?.isRemoved != true)
            } catch (err) {
                console.log('Error Fetching work records: ', err)
            }
        },

        async requestFetchReservationBlockAndColor() {
            try {
                let date = this.selectedDate
                // 진행 중인 이전 조회 취소 — 레거시 axios cancelToken 흐름의 대체
                await Promise.all([
                    this.queryClient.cancelQueries({ queryKey: v2ReservationCellKeys.all }),
                    this.queryClient.cancelQueries({ queryKey: v2ReservationBlockKeys.all })
                ])

                let hospitalID = this.hospital.selectedHospital._id
                let params = {
                    hospitalID: hospitalID,
                    columnID: this.columnIds,
                    date: date,
                    isRemoved: false,
                    key: 'modifiedAt',
                    way: -1
                }
                // 기존 동작 미러링: 한쪽만 봉투 에러면 undefined 로 두고, 둘 다 실패했을 때만 throw
                const swallowApiError = (err) => {
                    if (!isApiErrorWithCode(err)) throw err
                    return { apiError: err }
                }
                let [cellsResult, blocksResult] = await Promise.all([
                    this.queryClient.fetchQuery(v2ReservationCellFindQueryOptions(params)).catch(swallowApiError),
                    this.queryClient.fetchQuery(v2ReservationBlockFindQueryOptions(params)).catch(swallowApiError)
                ])

                if (!this.isDateMatch(date)) {
                    return
                }

                const cellsFailed = cellsResult?.apiError !== undefined
                const blocksFailed = blocksResult?.apiError !== undefined
                if (cellsFailed && blocksFailed) {
                    throw new Error(cellsResult.apiError.message || blocksResult.apiError.message)
                }
                this.originalBlocksAndColors = deepCopy(this.parseBlockAndColorData(
                    cellsFailed ? undefined : cellsResult,
                    blocksFailed ? undefined : blocksResult
                ))
            } catch (err) {
                // 취소(새 요청으로 대체)는 로그하지 않는다 — 기존 axios.isCancel 미러링
                if (err?.name !== 'CancelledError' && !axios.isCancel(err)) {
                    console.log('Error Fetching reservation blocks & colors: ', err)
                }
            }
        },
        async requestFetchReservationUserNotes() {
            try {
                const hospitalID = this.hospital.selectedHospital._id
                const startedAt = moment(this.selectedDate).startOf('days').toString()
                const endedAt = moment(this.selectedDate).endOf('days').toString()

                const param = { hospitalID, startedAt, endedAt }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                setReservationUserNotes(await this.queryClient.fetchQuery(v2ReservationUserNoteFindDateQueryOptions(param)))
            } catch (err) {
                console.log('Error Fetching user note: ', err)
            }
        },

        // MARK: - Private
        moveToReservationCell() {
            let elScroll = this.$refs.scroll
            if (elScroll == undefined) {
                return
            }
            let elReservation = this.reservationSelection.selectedReservationElement
            let reservationLeftMargin = elReservation?.offsetLeft + elReservation.offsetParent?.offsetLeft
            let offsetRight = reservationLeftMargin + elReservation.offsetWidth
            let scrollOffsetRight = elScroll.offsetWidth + elScroll.scrollLeft
            if (offsetRight > scrollOffsetRight) {
                elScroll.scrollLeft = offsetRight - elScroll.offsetWidth
                return
            }

            let offsetLeft = reservationLeftMargin
            let scrollOffsetLeft = elScroll.scrollLeft
            if (offsetLeft < scrollOffsetLeft) {
                elScroll.scrollLeft = offsetLeft
            }
        },

        isDateMatch(fetchParamDate) {
            return fetchParamDate == this.selectedDate
        },
        parseBlockAndColorData(c, b) {
            let colors = c?.map((c) => ({ ...c, cellType: 'color' })) ?? []

            let blocks =
                b
                    ?.map((b) => {
                        if (!b.startTime || !b.endTime) {
                            return null
                        }
                        let { start, end } = this.parseTime(b)
                        return {
                            ...b,
                            cellType: 'block',
                            startedAt: start,
                            endedAt: end
                        }
                    })
                    .filter((b) => b != null) ?? []

            return [...blocks, ...colors]
        },
        parseTime(data) {
            let time = moment(this.selectedDate)
            let start, end
            if (data.isDaybreak) {
                start = time.clone().set({ hour: 0, minute: 0 })
                end = time.clone().set({ hour: 23, minute: 55 })
            } else {
                let [sh, sm] = data.startTime.split(':')
                let [eh, em] = data.endTime.split(':')
                start = time.clone().set({ hour: sh, minute: sm })
                end = time.clone().set({ hour: eh, minute: em })
            }
            return { start, end }
        }
    }
}
</script>
